import { paginationConstants } from '../constants'

export const initialState = {
  totalRecords: null,
  currentPage: null
}

export default function page(state = initialState, action) {
  switch (action.type) {
    case paginationConstants.PAGINATION_REQUEST:
      return {
        ...state,
        currentPage: action.page
      }
    default:
      return state
  }
}
